import React from 'react';

import reserving from '~/common/images/reserving.png';
import styles from './loadingSpinner.css';

const LoadingSpinner = (props) => {
    const { className, wrapperClassName, text } = props;
    return (
        <div className={`${styles.wrapper} ${wrapperClassName || ''}`}>
            <img
                alt="Loading Request"
                className={`${styles.loading} ${className || ''}`}
                src={reserving}
                title="Loading Request"
            />
            {text ? <span className={styles.copy}>{text}</span> : null}
        </div>
    );
};

export default LoadingSpinner;
